exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1nVCu {\n  position: fixed;\n  z-index: 200;\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n          box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .2);\n  cursor: wait; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1nVCu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/busy-indicator/busy-indicator.scss
// module id = GLqN
// module chunks = 1